import { Pipe, PipeTransform } from 'angular-ts-decorators';

/**
 * @param {string} input string to be shorten
 * @param {number} maxLength length of shorter version
 * @returns {string} shorten string
 * Filter that returns the input string with … if it's longer than expected.
 */
@Pipe({ name: 'ellipsis' })
export class EllipsisPipe implements PipeTransform {
  constructor() {
    'ngInject';
  }

  public transform(input: string, maxLength: number) {
    if (!angular.isString(input)) {
      return '';
    }

    if (angular.isNumber(maxLength) && input.length > maxLength) {
      return input.substring(0, maxLength) + '…';
    } else {
      return input;
    }
  }
}
